import GmailIcon from './lib/icon-gmail.svg';
import GoogleAgendaIcon from './lib/icon-google-agenda.svg';
import GoogleIcon from './lib/icon-google.svg';

export * from './lib/hosted-auth';
export * from './lib/dashboard';
export * from './lib/dashboard/oauth-scopes';

export { GmailIcon, GoogleAgendaIcon, GoogleIcon };
export const gmailName = 'Gmail';
export const googleAgendaName = 'Google Agenda';
export const googleName = 'Google';

export const googleProductIcons: Record<string, string> = {
  default: GoogleIcon,
  gmail: GmailIcon,
  calendar: GoogleAgendaIcon,
};

export const googleProductLabels: Record<string, string> = {
  default: googleName,
  gmail: gmailName,
  calendar: googleAgendaName,
};
